import { BrushHandleRenderProps } from '@visx/brush/lib/BrushHandle';
import { Group } from '@visx/group';

import { cn } from '@blockworks/ui/system';

import { BRUSH_HANDLE_CLASSNAME } from '../timeseries.model';

function BrushHandle({ x, height, isBrushActive, width }: BrushHandleRenderProps) {
    const handle = 16;
    const offset = height / 2 - handle / 2;
    if (!isBrushActive) {
        return null;
    }
    return (
        <Group left={x + width / 2} top={offset}>
            <path
                transform="scale(1)"
                d="M -4.5 0.5 L 3.5 0.5 L 3.5 15.5 L -4.5 15.5 L -4.5 0.5 M -1.5 4 L -1.5 12 M 0.5 4 L 0.5 12"
                strokeWidth="1"
                stroke={'var(--color-surface-interact)'}
                fill={'var(--color-current-bg)'}
                style={{ cursor: 'ew-resize' }}
                className={cn(
                    // ensures screenshot helpers can grab this DOM node to compute styles
                    BRUSH_HANDLE_CLASSNAME,
                    'fill-current-bg stroke-surface-interact',
                )}
            />
        </Group>
    );
}

export { BrushHandle };
